module.exports = __webpack_public_path__ + "img/vela.af8dd9e0.svg";